<mat-toolbar color="accent"
  >Select Surfaces for {{ data.chartedItemConfiguration.name }}</mat-toolbar
>

<mat-dialog-content>
  <pr-available-surfaces
    [tooth]="data.tooth"
    [surfaces]="data.surfaces"
    [selectableSurfaces]="data.selectableSurfaces"
    (selectedSurfaces)="selectedSurfaces$.next($event)"
  />
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <button mat-flat-button color="primary" (click)="save()">Save</button>
  </pt-buttons-container>
</mat-dialog-actions>
